import React from 'react';
import aboutUsData from '../../data/about-us.json';

const hero = aboutUsData.hero;

export default function AboutHero() {
    return (
        <section className="au-hero">
            <style>{`
                .au-hero {
                    position: relative;
                    min-height: 65vh;
                    display: flex;
                    align-items: center;
                    overflow: hidden;
                    padding: 150px 0 80px;
                    background: var(--eventflow-black);
                }
                .au-hero__bg {
                    position: absolute; inset: 0;
                    background-image: url('${process.env.PUBLIC_URL}/hero%20background.jpeg');
                    background-size: cover;
                    background-position: center top;
                    z-index: 0;
                }
                .au-hero__overlay {
                    position: absolute; inset: 0;
                    background: linear-gradient(110deg,
                        rgba(4,0,10,0.92) 0%,
                        rgba(4,0,10,0.75) 55%,
                        rgba(4,0,10,0.55) 100%);
                    z-index: 1;
                }
                .au-hero::after {
                    content: '';
                    position: absolute; inset: 0;
                    background-image:
                        linear-gradient(rgba(255,255,255,0.02) 1px, transparent 1px),
                        linear-gradient(90deg, rgba(255,255,255,0.02) 1px, transparent 1px);
                    background-size: 60px 60px;
                    pointer-events: none; z-index: 2;
                }
                .au-hero__inner {
                    position: relative; z-index: 3;
                }
                .au-hero__tag {
                    display: inline-flex; align-items: center; gap: 8px;
                    font-family: var(--eventflow-font);
                    font-size: 12px; font-weight: 700;
                    letter-spacing: 3px; text-transform: uppercase;
                    color: var(--eventflow-base); margin-bottom: 20px;
                }
                .au-hero__tag::before, .au-hero__tag::after {
                    content: ''; display: inline-block;
                    width: 28px; height: 1px;
                    background: var(--eventflow-base); opacity: 0.5;
                }
                .au-hero__title {
                    font-family: var(--eventflow-font);
                    font-size: 68px; font-weight: 900;
                    color: #fff; line-height: 1.0;
                    letter-spacing: -2px; margin-bottom: 20px;
                    text-transform: uppercase;
                }
                .au-hero__title span {
                    background: linear-gradient(135deg, var(--eventflow-base) 0%, #ff4d9e 100%);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                    background-clip: text;
                }
                .au-hero__sub {
                    font-family: var(--eventflow-font);
                    font-size: 17px; color: rgba(255,255,255,0.55);
                    max-width: 600px; margin-bottom: 40px; line-height: 1.75;
                }
                .au-hero__pills {
                    display: flex; flex-wrap: wrap; gap: 10px;
                }
                .au-hero__pill {
                    display: inline-flex; align-items: center; gap: 7px;
                    background: rgba(255,255,255,0.05);
                    border: 1px solid rgba(255,255,255,0.1);
                    border-radius: 50px; padding: 8px 18px;
                    font-family: var(--eventflow-font);
                    font-size: 13px; color: rgba(255,255,255,0.6);
                    transition: all 0.25s;
                }
                .au-hero__pill:hover {
                    border-color: rgba(var(--eventflow-base-rgb),0.4);
                    color: #fff;
                }
                .au-hero__pill i { color: var(--eventflow-base); font-size: 12px; }
                @media (max-width: 768px) {
                    .au-hero { padding: 130px 0 60px; min-height: auto; }
                    .au-hero__title { font-size: 42px; letter-spacing: -1px; }
                }
            `}</style>

            <div className="au-hero__bg" />
            <div className="au-hero__overlay" />

            <div className="container">
                <div className="au-hero__inner wow fadeInUp" data-wow-delay="100ms">
                    <div className="au-hero__tag">{hero.tag}</div>
                    <h1 className="au-hero__title">
                        {hero.titleLine1} <span>{hero.titleAccent}</span><br />{hero.titleLine2}
                    </h1>
                    <p className="au-hero__sub">{hero.subtitle}</p>
                    <div className="au-hero__pills">
                        {hero.pills.map((pill, i) => (
                            <span className="au-hero__pill" key={i}>
                                <i className={pill.icon} />{pill.text}
                            </span>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
